/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_AiffInputs */

const en_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const es_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const fr_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const de_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const ja_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const zh_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const ar_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const id_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const it_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const ru_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const pt_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

const ko_val_aiff = /** @type {(inputs: Val_AiffInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIFF`)
};

/**
* | output |
* | --- |
* | "AIFF" |
*
* @param {Val_AiffInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_aiff = /** @type {((inputs?: Val_AiffInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_AiffInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_aiff(inputs)
	if (locale === "es") return es_val_aiff(inputs)
	if (locale === "fr") return fr_val_aiff(inputs)
	if (locale === "de") return de_val_aiff(inputs)
	if (locale === "ja") return ja_val_aiff(inputs)
	if (locale === "zh") return zh_val_aiff(inputs)
	if (locale === "ar") return ar_val_aiff(inputs)
	if (locale === "id") return id_val_aiff(inputs)
	if (locale === "it") return it_val_aiff(inputs)
	if (locale === "ru") return ru_val_aiff(inputs)
	if (locale === "pt") return pt_val_aiff(inputs)
	return ko_val_aiff(inputs)
});